import { ArrowRight, Camera } from "lucide-react";
import { Link } from "react-router";
import { MODULE_ADDON_SECTION_LABEL } from "../data/moduleCatalog";
import type { WebcamHighlightContent } from "../data/planCatalog";

type WebcamHighlightBlockProps = WebcamHighlightContent & {
  className?: string;
};

export function WebcamHighlightBlock({
  summary,
  useCases,
  className = "",
}: WebcamHighlightBlockProps) {
  return (
    <aside
      className={`rounded-xl border border-violet-500/25 bg-slate-900/80 px-5 py-4 ${className}`}
      aria-label="Optional Webcam Capture add-on"
    >
      <p className="text-violet-200/90 text-xs font-semibold uppercase tracking-wider mb-2">
        {MODULE_ADDON_SECTION_LABEL}
      </p>
      <div className="flex items-center gap-2 mb-3">
        <Camera size={16} className="text-violet-400/90 shrink-0" />
        <p className="text-slate-200 text-sm font-semibold">Webcam Capture</p>
      </div>
      <p className="text-on-dark-muted text-sm leading-relaxed mb-4">{summary}</p>
      {useCases.length > 0 && (
        <ul className="space-y-2 mb-4">
          {useCases.map((item) => (
            <li key={item} className="flex items-start gap-2 text-sm text-on-dark-muted">
              <span className="text-violet-400/80 mt-1 shrink-0">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        <Link
          to="/pricing#webcam-capture-addon"
          className="inline-flex items-center gap-1 text-teal-400 hover:text-teal-300 text-sm font-medium transition-colors"
        >
          See Webcam Capture pricing
          <ArrowRight size={14} />
        </Link>
        <Link
          to="/features#webcam-capture"
          className="inline-flex items-center gap-1 text-teal-400 hover:text-teal-300 text-sm font-medium transition-colors"
        >
          Learn about Webcam Capture
          <ArrowRight size={14} />
        </Link>
      </div>
    </aside>
  );
}
